// Module
var code = `<bds-grid padding="3" gap="3" class="instructions__container instructions__actions-footer" ng-transclude> </bds-grid>`;
// Exports
module.exports = code;